import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeProtection } from './utils/antiDebug';

// Initialize security protections
if (process.env.NODE_ENV === 'production') {
  initializeProtection({
    disableDevTools: true,
    disableRightClickMenu: true,
    disableKeyboardShortcuts: true,
    preventIframe: true,
    checkIntegrity: true,
    antiDebug: false // Set to true for maximum protection (may affect performance)
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
